import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import Card from "../../../components/Card";
import DataTable from "react-data-table-component";
import { Row, Col } from "react-bootstrap";
import RegistrasiService from "../../../services/registrasi/RegistrasiService";

const ModalUPT = ({ showUPT, handleCloseUPT, setKodeUPT, setNamaUPT }) => {
  let RegService = useMemo(() => new RegistrasiService(), [])
  const columns = [
    {
      name: "KODE UPT",
      cell: (row) => row["KD_UNIT"],
      width: "100px"
    },
    {
      name: "NAMA UPT",
      cell: (row) => row["NM_UNIT_BARU"],
    },
  ];

  const [upts, setUpts] = useState([]);
  const [filterRecord, setFilterRecord] = useState([])

  const getUpts = async () => {
    try {
      const response = await RegService.getAllUpt();
      setUpts(response.data)
      setFilterRecord(response.data)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUpts();
  }, []);

  const [pilihUpt, setPilihUpt] = useState(false);
  const handleClosePilihUPT = () => setTidakPilih(false);
  const [tidakPilih, setTidakPilih] = useState(false);

  const PilihUPT = (row) => {
    if (pilihUpt) {
      handleCloseUPT();
    } else {
      setTidakPilih(!pilihUpt)
    }
  };

  const handleBatal = () => {
    handleCloseUPT();
  };

  const handleFilter = (event) => {
    const newData = filterRecord.filter(row => row["NM_UNIT"].toLowerCase().includes(event.target.value.toLowerCase()))
    setUpts(newData)
  }

  const handleSelect = (row) => {
    if (row.selectedCount === 1) {
      // setKodeUPT({ ...user, KD_UNIT: row.selectedRows[0].KD_UNIT })
      // SpeechSynthesisUtterance.
      setKodeUPT(row.selectedRows[0].KD_UNIT)
      setNamaUPT(row.selectedRows[0].NM_UNIT_BARU)
      setPilihUpt(true)
    }
    else setPilihUpt(false)
  }

  return (
    <>
      <Modal
        show={showUPT}
        onHide={handleCloseUPT}
        backdrop="static"
        keyboard={false}
        scrollable={true}
        size="xl"
        centered
      >
        <Modal.Header>
          <h6>Unit Pelaksana Teknis BPPMHKP</h6>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm="12">
              <Card>
                <Card.Header className="d-flex justify-content-between">
                  <div>
                    <input
                      className="form-control me-2"
                      type="text"
                      placeholder="Search"
                      aria-label="Search"
                      onChange={handleFilter}
                    />
                  </div>
                </Card.Header>
                <Card.Body>
                  <div className="table-responsive border-bottom my-3">
                    {/* {loading && <Spinner />} */}
                    <DataTable
                      customStyles={{
                        headCells: {
                          style: {
                            "background-color": "#00acee",
                            color: "white",
                          },
                        },
                      }}
                      columns={columns}
                      data={upts}
                      highlightOnHover
                      pagination
                      selectableRows
                      onRowClicked={handleSelect}
                      onSelectedRowsChange={handleSelect}
                      selectableRowsSingle
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" size="sm" onClick={() => PilihUPT()}>
            Pilih
          </Button>
          <Button variant="danger" size="sm" onClick={() => handleBatal()}>
            Batal
          </Button>
        </Modal.Footer>
      </Modal>
      {
        tidakPilih &&
        <SweetAlert
          title="Pilih 1 UPT"
          danger
          onConfirm={handleClosePilihUPT}
          btnSize="sm"
        />
      }
    </>
  );
};

export default ModalUPT;
